import React from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Table } from '@gaiads/telia-react-component-library';
import { LocalBundleItem, LocalProductVariant } from '@cdaas/api-clients/dist/product-service-openapi';

import { Availability } from '../../../shared/ListUtil/Availability';

interface VariantListItemProps {
  item: LocalBundleItem;
  option: LocalProductVariant;
  main?: boolean;
}

const VariantListItem = ({ item, option }: VariantListItemProps) => {
  const { t } = useTranslation('bundlesview');
  const { name } = item;
  const { available_amount } = option;

  return (
    <Table.Row className="telia-react-table_row__child">
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell className="daas-product-table__name">
        <BodyText>
          {`${t('bundles_table.addons')}: `}
          {name}
        </BodyText>
      </Table.Cell>
      <Table.Cell className="daas-product-table__availability">
        <Availability availableAmount={available_amount} />
      </Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
    </Table.Row>
  );
};

export default VariantListItem;
